

// converts lat lng to degree-minutes-seconds format
export function toDMS(lat, lng, acc) {
    let toSec = function (deg) {
        let d = Math.floor(Math.abs(deg));
        let minfloat = (Math.abs(deg) - d) * 60;
        let m = Math.floor(minfloat);
        let secfloat = (minfloat - m) * 60;
        let s = secfloat.toFixed((acc - 2) < 0 ? 0 : acc - 2);
        if (s < 10) {
            s = "0" + s;
        }
        if (m == 60) {
            d++;
            m = "00";
        }
        if (m < 10) {
            m = "0" + m;
        }

        return [d,m,s]
    }

    if (lng > 180)
        lng = lng - 360;

    let lngPrefix = (lng < 0) ? 'W' : 'E';
    let latPrefix = (lat < 0) ? 'S' : 'N';
    let latD = toSec(lat)
    let lngD = toSec(lng)
    lngD = lngD[0] + "°" + lngD[1] + "'" + lngD[2] + "''" + lngPrefix
    latD = latD[0] + "°" + latD[1] + "'" + latD[2] + "''" + latPrefix

    return (latD + "," + lngD);
}
